const baseMapConfig = {
  c20250326081877: {
    point1Lng: "113.0766620",
    point1Lat: "23.1635141",
    f1X: "0.61",
    f1Y: "0.56",
    point2Lng: "112.5431404",
    point2Lat: "22.7706042",
    f2X: "0.23",
    f2Y: "0.85",
    centerX: "0.64",
    centerY: "0.61",
  },
  C20220505145814: {
    point1Lng: "113.7371852",
    point1Lat: "23.1469021",
    f1X: "0.32",
    f1Y: "0.12",
    point2Lng: "114.1861943",
    point2Lat: "22.6610268",
    f2X: "0.85",
    f2Y: "0.95",
    centerX: "0.22",
    centerY: "0.27",
  },
};

export { baseMapConfig };
